import { getuChannelPromotionList } from '@/api/channelPromotion'
import { getuLandPageList } from '@/api/landPage'
import { defineStore } from 'pinia'

export const useChannelStore = defineStore('channel', {
  state: () => ({
    apiLandPageOptions: [],
    apiLandPageOptionUrls: [],
  }),
  actions: {
    async getLandPageGroup() {
      let data = {
        page: 1,
        pageSize: 1000,
      }
      const res = await getuLandPageList(data)
      if (res.code === 0) {
        const list = res.data.list
        this.apiLandPageOptions = list.map((item) => ({
          label: item.name,
          value: item.id,
        }))
        this.apiLandPageOptionUrls = list.map((item) => ({
          label: item.page_url,
          value: item.id,
        }))
      }
    },
  },
}) 